import { $api } from "../generated/client.ts";

type ReturnRequestsRatesTimeChartParams = {
  fromTimestamp: number;
  toTimestamp: number;
  resolution?: string;
  reason?: string;
  country?: string;
  productId?: string;
  variantId?: string;
  catalogId?: string;
  includeAllOrders?: boolean;
};

export default function useReturnRequestsRatesTimeChart(
  shopId: string,
  params: ReturnRequestsRatesTimeChartParams,
) {
  return $api.useQuery(
    "get",
    "/shops/{shopId}/statistics/return-requests-rates",
    {
      params: {
        path: { shopId },
        query: params,
      },
      enabled: !!params.toTimestamp,
    },
  );
}
